import React from "react";
import ListContentsByRedisTime from "../../Services/Queries/ListContentsByRedisTime";
import DeleteContent from "../../Services/Mutations/DeleteContent";
import { Link } from "react-router-dom";
import { Button, Modal, Table } from "react-bootstrap";
import { Auth } from "aws-amplify";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CopyToClipboard } from "react-copy-to-clipboard";

import AwsConfig from "../../Config/AwsConfig";
import ModifyContentPoints from "../../Services/Mutations/ModifyContentPoints";
import "../../App.css";

import { Menu, MenuItem, MenuButton, SubMenu } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import NewsOnTop from "./NewsOnTop";
import AddPointsToContent from "./AddPointsToContent";
import DeleteContentAction from "./DeleteContentAction";
import AddContentToBoxOfficeAction from "./AddContentToBoxOfficeAction";
import ArchiveContentAction from "./ArchiveContentAction";
import ShareContentAction from "./ShareContentAction";
import SortableList, { SortableItem } from "react-easy-sort";
import ContentStickyActions from "./ContentStickyActions";
import AddContentToListAction from "./AddContentToListAction";
import GetUserPermissions from "../../Services/Queries/GetUserPermissions";
import { DefinedPermissions } from "../Constants/Permissions";
import Header from "../header";
import Spinner from "../header/Spinner";
import SendPushNotification from "./SendContentPushNotification";
const styles = {
  fontSize: {
    fontSize: "12px",
  },
};
class RankContents extends React.Component {
  toastStyle = {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };
  constructor(props) {
    super(props);

    this.state = {
      filtered: false,
      selectionRange: {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      },
      archiveModalVisible: false,
      addToBoxOfficeModalVisible: false,
      showDatePicker: false,
      error: false,
      publishedContentsList: [],
      limit: 100,
      nextToken: null,
      render: false,
      endReached: false,
      loadMore: false,
      props: props,
      userDetails: {},
      userPermissions: [],
      reload: false,
      contentSelectedLang: null,
      currentPage: 1,

      deleteModalVisible: false,
      selectedContentId: "",
      selectedContentLanguages: [],
      capturePostModal: false,
      selectedItem: null,
      displayDescription: "",
      displayContents: [
        "Story",
        "CoverStory",
        "Mcq",
        "Poll",
        "SlideShow",
        "liveNews",
      ],
      contentsTypes: [
        "Story",
        "CoverStory",
        "Mcq",
        "Poll",
        "SlideShow",
        "liveNews",
      ],
      paginationCount: 1,
      render: false,
      loggedInUserPermissions: [],
      appLanguage: "",
      loading: false,
    };

    this.loadMore = this.loadMore.bind(this);
  }
  loadMore = async () => {
    await this.getNextContentsList();
  };
  onSortEnd = async (oldIndex, newIndex) => {
    const { publishedContentsList, dragId } = this.state;
    const dragItem = publishedContentsList[oldIndex];
    const dropItem = publishedContentsList[newIndex];
    const dragIndex = oldIndex;
    const dropIndex = newIndex;
    console.log(dropIndex, "dropIndex");
    console.log(dragIndex, "dragIndex");
    console.log(dragItem, "dragItemdragItem");

    if (dragIndex != dropIndex) {
      let loggedInUserHandle = "";
      const loggedInUserEmail = Auth.user.attributes
        ? Auth.user.attributes.email
        : "";
      if (loggedInUserEmail) {
        const emailParams = loggedInUserEmail.split("@");
        loggedInUserHandle = "@" + emailParams[0];
      }
      console.log("dragItemdragItem", dragItem);
      let isDraggedStickyPost = false;
      if (
        dragItem.stickyPost != undefined &&
        dragItem.stickyPost != null &&
        dragItem.stickyPost
      ) {
        isDraggedStickyPost = true;
      } else if (
        dragItem.isInAppMessage != undefined &&
        dragItem.isInAppMessage != null &&
        dragItem.isInAppMessage
      ) {
        if (
          dragItem.inAppMessageDetails != undefined &&
          dragItem.inAppMessageDetails != null &&
          Object.keys(dragItem.inAppMessageDetails).length > 0
        ) {
          isDraggedStickyPost = true;
        }
      }
      const parameters = {
        contentID: dragItem.PK,
        newsOnTopFor: "rank",
        ModeratorID: Auth.user.username,
        moderatorHandle: loggedInUserHandle,
        rank: parseInt(dropIndex) + 1,
        fromPosition: parseInt(dragIndex) + 1,
        isDraggedStickyPost,
      };
      console.log(parameters, "parameters");
      try {
        if (!isDraggedStickyPost) {
          const response = await ModifyContentPoints(parameters);
          console.log(response, "responseeeeeeeeeeee=============");

          if (response.statusCode == "A261") {
            var element = publishedContentsList[dragIndex];
            publishedContentsList.splice(dragIndex, 1);
            publishedContentsList.splice(dropIndex, 0, element);
            toast.success("Ranked Successfully", this.toastStyle);

            this.setState({ publishedContentsList: publishedContentsList });
          } else {
            toast.error("Failed To Rank the content", this.toastStyle);
          }
        } else if (isDraggedStickyPost) {
          console.log("it is a dragged post");
          toast.error(
            "You Cannot Drag Sticky Post or Campaign",
            this.toastStyle
          );
        }
      } catch (error) {
        return error;
      }
    }
  };
  checkCopied = () => {
    toast.success("Copied Successfully", this.toastStyle);
  };
  getContentsList = async () => {
    this.setState({ loading: true });
    const { limit, paginationCount } = this.state;
    const input = {
      limit: limit,
      nextToken: null,
      paginationCount,
      language: this.state.appLanguage,
    };

    console.log(input, "input firstt========");
    const publishedContentsList = await ListContentsByRedisTime(input);
    console.log(publishedContentsList, "redis contents listtt=====");

    const permissionInput = {
      mobileNumber: Auth.user.attributes.phone_number,
    };
    const userPermissions = await GetUserPermissions(permissionInput);
    let permissions = [];
    let permissionsArr = [];
    if (userPermissions && userPermissions.userRolesAndPermissions) {
      userPermissions.userRolesAndPermissions.map((item) => {
        permissions.push(...item.permissions);
      });
      permissions.map((permission) => {
        permissionsArr.push(permission.name);
      });
    }
    this.setState({
      loading: false,
      render: true,
      nextToken: publishedContentsList.nextToken,
      publishedContentsList: publishedContentsList.items,
      paginationCount: paginationCount + 1,
      loggedInUserPermissions: permissionsArr,
    });
  };
  getNextContentsList = async () => {
    const { limit, filtered, paginationCount } = this.state;
    const input = {
      limit: limit,
      nextToken: this.state.nextToken,
      paginationCount,
      language: this.state.appLanguage,
    };
    if (filtered) {
      const { selectionRange, limit } = this.state;
      const epochStartTime = selectionRange.startDate.getTime();
      const epochEndTime = selectionRange.endDate.getTime();
      const startTime = Math.trunc(epochStartTime / 1000);
      const endTime = Math.trunc(epochEndTime / 1000);
      input.fromTime = startTime;
      input.toTime = endTime;
    }
    console.log(input, "inputttttttnextttttttt");
    const data = await ListContentsByRedisTime(input);
    console.log(data.items, "next dataaaaaaaaaaaaaaaaaaaa");
    if (data.nextToken == null) {
      this.setState({
        paginationCount: paginationCount + 1,
        publishedContentsList: [
          ...this.state.publishedContentsList,
          ...data.items,
        ],
        nextToken: null,
      });
    } else {
      this.setState({
        paginationCount: paginationCount + 1,
        publishedContentsList: [
          ...this.state.publishedContentsList,
          ...data.items,
        ],
        nextToken: data.nextToken,
      });
    }
  };
  changeAppLanguage = async (e) => {
    const { appLanguage } = this.state;
    console.log(e, "eeeeeeeeeee");
    console.log(e.target.value, "e.target.value");
    const language = e.target.value;
    if (language && appLanguage != language) {
      this.setState({ appLanguage: language, paginationCount: 1 }, async () => {
        console.log("in list pn counterssssss");
        await this.getContentsList();
      });
      localStorage.setItem("appLanguage", language);
    }
  };
  componentDidMount = async () => {
    let appLanguage = localStorage.getItem("appLanguage");
    appLanguage = appLanguage ? appLanguage : "Telugu";
    console.log(appLanguage, "appLanguage");
    this.setState({ appLanguage: appLanguage }, async () => {
      await this.getContentsList();
    });
  };
  // componentDidMount = async () => {
  // 	await this.getContentsList()
  // }

  getContenttitle = (item) => {
    let thumbnailTitle = "";

    const {
      storyDetails,
      coverStoryDetails,
      mcqDetails,
      slideShowDetails,
      pollDetails,
      liveCricketDetails,
      cricketPointsTableDetails,
      liveNewsSectionDetails,
    } = item.contentMetaInfo;
    const content = item;
    let lang = "En";
    if (item.contentLanguages) {
      lang = item.contentLanguages.includes("En") ? "En" : "Te";
    }
    const contentType =
      item.storyType && item.storyType != ""
        ? item.storyType
        : item.contentType;

    switch (contentType) {
      case "Story":
      case "ShortByte":
        thumbnailTitle = storyDetails && storyDetails[`storyTitle_${lang}`];
        break;
      case "Mcq":
        thumbnailTitle = mcqDetails && mcqDetails[`mcqTitle_${lang}`];
        break;
      case "Poll":
        thumbnailTitle = pollDetails && pollDetails[`pollTitle_${lang}`];
        break;
      case "CoverStory":
        const {
          flipToStoryDetails,
          onlyCoverDetails,
          inAppBrowserDetails,
        } = coverStoryDetails;
        switch (coverStoryDetails.coverStoryType) {
          case "FlipToStory":
            thumbnailTitle =
              flipToStoryDetails &&
              flipToStoryDetails[`coverStoryTitle_${lang}`];
            break;
          case "OnlyCover":
            thumbnailTitle =
              onlyCoverDetails && onlyCoverDetails[`coverStoryTitle_${lang}`];
            break;
          case "InAppBrowser":
            thumbnailTitle =
              inAppBrowserDetails &&
              inAppBrowserDetails[`coverStoryTitle_${lang}`];
            break;
          default:
            thumbnailTitle = "";
        }
        break;
      case "SlideShow":
        thumbnailTitle =
          slideShowDetails && slideShowDetails[`slideShowTitle_${lang}`];
        break;
      case "liveCricketScore":
        thumbnailTitle =
          liveCricketDetails && liveCricketDetails[`liveCricketTitle_${lang}`];
        break;
      case "cricketPointsTable":
        thumbnailTitle =
          cricketPointsTableDetails &&
          cricketPointsTableDetails[`cricketPointsTableTitle_${lang}`];
        break;
      case "liveNews":
        thumbnailTitle = liveNewsSectionDetails
          ? liveNewsSectionDetails.length > 0
            ? liveNewsSectionDetails[0][`liveNewsTitle_${lang}`]
            : ""
          : "";
        break;
      default:
        thumbnailTitle = "";
    }
    return thumbnailTitle;
  };
  getContentUri = (item) => {
    let uri;
    const {
      storyDetails,
      coverStoryDetails,
      mcqDetails,
      pollDetails,
      slideShowDetails,
      thumbnailURL,
      liveCricketDetails,
      cricketPointsTableDetails,
      liveNewsSectionDetails,
    } = item.contentMetaInfo;
    const cdnurl = AwsConfig.cdn_url;
    const contentType =
      item.storyType && item.storyType != ""
        ? item.storyType
        : item.contentType;

    switch (contentType) {
      case "Story":
      case "ShortByte":
        uri =
          storyDetails.storyCardImages &&
          storyDetails.storyCardImages[0] &&
          storyDetails.storyCardImages[0].image;
        if (uri == undefined && thumbnailURL) {
          uri = thumbnailURL;
        }
        if (uri && !uri.includes(cdnurl)) {
          uri = cdnurl + uri;
        }
        if (uri == undefined && storyDetails.youtubeID != "") {
          uri = `https://img.youtube.com/vi/${storyDetails.youtubeID}/default.jpg`;
        }
        break;
      case "Mcq":
        uri =
          mcqDetails.mcqImages &&
          mcqDetails.mcqImages[0] &&
          mcqDetails.mcqImages[0].image;
        if (uri && !uri.includes(cdnurl)) {
          uri = cdnurl + uri;
        }
        break;
      case "Poll":
        uri =
          pollDetails.pollImage &&
          pollDetails.pollImage[0] &&
          pollDetails.pollImage[0].image;
        if (uri && !uri.includes(cdnurl)) {
          uri = cdnurl + uri;
        }
        break;
      case "CoverStory":
        const {
          flipToStoryDetails,
          onlyCoverDetails,
          inAppBrowserDetails,
        } = coverStoryDetails;
        switch (coverStoryDetails.coverStoryType) {
          case "FlipToStory":
            uri =
              flipToStoryDetails.coverStoryImages &&
              flipToStoryDetails.coverStoryImages[0] &&
              flipToStoryDetails.coverStoryImages[0].image;
            if (uri == undefined && thumbnailURL) {
              uri = thumbnailURL;
            }
            if (uri && !uri.includes(cdnurl)) {
              uri = cdnurl + uri;
            }
            if (uri == undefined && flipToStoryDetails.youtubeID != "") {
              uri = `https://img.youtube.com/vi/${flipToStoryDetails.youtubeID}/default.jpg`;
            }
            break;
          case "OnlyCover":
            uri =
              onlyCoverDetails.coverStoryImages &&
              onlyCoverDetails.coverStoryImages[0] &&
              onlyCoverDetails.coverStoryImages[0].image;
            if (uri == undefined && thumbnailURL) {
              uri = thumbnailURL;
            }
            if (uri && !uri.includes(cdnurl)) {
              uri = cdnurl + uri;
            }
            if (uri == undefined && onlyCoverDetails.youtubeID != "") {
              uri = `https://img.youtube.com/vi/${onlyCoverDetails.youtubeID}/default.jpg`;
            }
            break;
          case "InAppBrowser":
            uri =
              inAppBrowserDetails.coverStoryImages &&
              inAppBrowserDetails.coverStoryImages[0] &&
              inAppBrowserDetails.coverStoryImages[0].image;
            if (uri && !uri.includes(cdnurl)) {
              uri = cdnurl + uri;
            }
            break;
          default:
            uri = "";
        }
        break;
      case "SlideShow":
        uri = slideShowDetails && slideShowDetails.slideShowImage;
        if (uri == undefined && thumbnailURL) {
          uri = thumbnailURL;
          if (uri && !uri.includes(cdnurl)) {
            uri = cdnurl + uri;
          }
        } else if (uri && !uri.includes(cdnurl)) {
          uri = cdnurl + uri;
        }
        break;
      case "liveCricketScore":
        uri =
          liveCricketDetails.liveCricketImages &&
          liveCricketDetails.liveCricketImages[0] &&
          liveCricketDetails.liveCricketImages[0].image;
        if (uri && !uri.includes(cdnurl)) {
          uri = cdnurl + uri;
        }

        break;

      case "cricketPointsTable":
        uri =
          cricketPointsTableDetails &&
          cricketPointsTableDetails.cricketPointsTableImages &&
          cricketPointsTableDetails.cricketPointsTableImages[0] &&
          cricketPointsTableDetails.cricketPointsTableImages[0].image;
        if (uri && !uri.includes(cdnurl)) {
          uri = cdnurl + uri;
        }
        break;
      case "liveNews":
        // uri = "";
        if (liveNewsSectionDetails) {
          uri =
            liveNewsSectionDetails.length > 0
              ? liveNewsSectionDetails[0].liveNewsImages &&
                liveNewsSectionDetails[0].liveNewsImages[0] &&
                liveNewsSectionDetails[0].liveNewsImages[0].image
              : "";
          uri = uri && uri != "" && uri.includes(cdnurl) ? uri : cdnurl + uri;
          if (uri == undefined && liveNewsSectionDetails[0].youtubeID != "") {
            uri = `https://img.youtube.com/vi/${liveNewsSectionDetails[0].youtubeID}/default.jpg`;
          }
          if (!uri && thumbnailURL) {
            uri = thumbnailURL;
            if (uri && !uri.includes(cdnurl)) {
              uri = cdnurl + thumbnailURL;
            }
          }
        } else {
          uri = "";
        }
        break;
      default:
        uri = "";
    }
    return uri;
  };
  handleDrag = (ev) => {
    this.setState({ dragId: ev.currentTarget.id });
  };

  handleDrop = async (ev) => {
    const dragAndDropContentsToRank = this.state.loggedInUserPermissions.includes(
      DefinedPermissions["dragAndDropContentsToRank"]
    );
    if (dragAndDropContentsToRank) {
      const { publishedContentsList, dragId } = this.state;
      const dragItem = publishedContentsList.find((item) => item.PK === dragId);
      const dropItem = publishedContentsList.find(
        (item) => item.PK === ev.currentTarget.id
      );
      const dragIndex = publishedContentsList.findIndex(
        (section) => section.PK == dragId
      );
      const dropIndex = publishedContentsList.findIndex(
        (section) => section.PK == ev.currentTarget.id
      );
      console.log(dropIndex, "dropIndex");
      console.log(dragIndex, "dragIndex");
      console.log(dragItem, "dragItemdragItem");

      if (dragIndex != dropIndex) {
        let loggedInUserHandle = "";
        const loggedInUserEmail = Auth.user.attributes
          ? Auth.user.attributes.email
          : "";
        if (loggedInUserEmail) {
          const emailParams = loggedInUserEmail.split("@");
          loggedInUserHandle = "@" + emailParams[0];
        }
        let isDraggedStickyPost = false;
        if (
          dragItem.stickyPost != undefined &&
          dragItem.stickyPost != null &&
          dragItem.stickyPost
        ) {
          isDraggedStickyPost = true;
        } else if (
          dragItem.isInAppMessage != undefined &&
          dragItem.isInAppMessage != null &&
          dragItem.isInAppMessage
        ) {
          if (
            dragItem.inAppMessageDetails != undefined &&
            dragItem.inAppMessageDetails != null &&
            Object.keys(dragItem.inAppMessageDetails).length > 0
          ) {
            isDraggedStickyPost = true;
          }
        }
        const parameters = {
          contentID: dragItem.PK,
          newsOnTopFor: "rank",
          ModeratorID: Auth.user.username,
          moderatorHandle: loggedInUserHandle,
          rank: parseInt(dropIndex) + 1,
          fromPosition: parseInt(dragIndex) + 1,
          isDraggedStickyPost,
        };
        console.log(parameters, "parameters");
        try {
          if (!isDraggedStickyPost) {
            const response = await ModifyContentPoints(parameters);
            console.log(response, "responseeeeeeeeeeee=============");

            if (response.statusCode == "A261") {
              var element = publishedContentsList[dragIndex];
              publishedContentsList.splice(dragIndex, 1);
              publishedContentsList.splice(dropIndex, 0, element);
              toast.success("Ranked Successfully", this.toastStyle);

              this.setState({ publishedContentsList: publishedContentsList });
            } else {
              toast.error("Failed To Rank the content", this.toastStyle);
            }
          } else if (isDraggedStickyPost) {
            console.log("it is a dragged post");
            toast.error(
              "You Cannot Drag Sticky Post or Campaign",
              this.toastStyle
            );
          }
        } catch (error) {
          return error;
        }
      }
    } else {
      toast.error("You dont have permission to rank contents", this.toastStyle);
    }
  };
  displayToast = (type, message) => {
    if (type == "success") {
      toast.success(message, this.toastStyle);
    } else {
      toast.error(message, this.toastStyle);
    }
  };
  updateContentPoints = (contentID, points) => {
    const index = this.state.publishedContentsList.findIndex(
      (data) => data.PK == contentID
    );
    this.state.publishedContentsList[index].points =
      this.state.publishedContentsList[index].points + points;
    this.setState({ publishedContentsList: this.state.publishedContentsList });
  };
  replaceContentPoints = (contentID, points) => {
    const index = this.state.publishedContentsList.findIndex(
      (data) => data.PK == contentID
    );
    this.state.publishedContentsList[index].points = points;
    this.setState({ publishedContentsList: this.state.publishedContentsList });
  };
  updateArchivedList = (contentID, value) => {
    const index = this.state.publishedContentsList.findIndex(
      (data) => data.PK == contentID
    );
    this.state.publishedContentsList[index].archivedFromRedis = value;
    this.setState({ publishedContentsList: this.state.publishedContentsList });
  };
  refreshContents = (contentID, single, languages) => {
    if (single) {
      const index = this.state.publishedContentsList.findIndex(
        (data) => data.PK == contentID
      );
      let deletedLang;
      if (languages[0] == "English") {
        deletedLang = "En";
      } else {
        deletedLang = "Te";
      }
      let selectedIdContentLangs = this.state.publishedContentsList[index]
        .contentLanguages;
      selectedIdContentLangs = selectedIdContentLangs.filter(
        (lang) => lang !== deletedLang
      );

      this.state.publishedContentsList[
        index
      ].contentLanguages = selectedIdContentLangs;
      this.setState({
        publishedContentsList: this.state.publishedContentsList,
      });
    } else {
      const refreshContentsList = this.state.publishedContentsList.filter(
        (data) => {
          return data.PK != contentID;
        }
      );

      this.setState({ publishedContentsList: refreshContentsList });
    }
  };
  getFormattedDate = (date) => {
    var dd = date.getDate();
    var mm = date.getMonth() + 1;

    var yyyy = date.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    var formattedDate = dd + "/" + mm + "/" + yyyy;
    var hh = date.getHours();
    var m = date.getMinutes();
    var d = "AM";
    var h = hh;
    if (h >= 12) {
      h = hh - 12;
      d = "PM";
    }
    if (h == 0) {
      h = 12;
    }
    m = m < 10 ? "0" + m : m;
    const formattedTime = h + ":" + m + " " + d;
    return formattedDate + " " + formattedTime;
  };

  getPublishedDate = (time) => {
    const pubDate = new Date(time * 1000);
    const PublishedDate = this.getFormattedDate(pubDate);
    return PublishedDate;
  };
  renderTableRow = (item, index) => {
    const localOrStaging =
      window.location.href.indexOf("localhost") !== -1 ||
      window.location.href.indexOf("webstaging") !== -1;
    const CheckLoggedInPermission =
      Auth.user.attributes.phone_number == "+919491870436" ||
      Auth.user.attributes.phone_number == "+918008768588" ||
      Auth.user.attributes.phone_number == "+918099172176";
    const publishedContentsNewsOnTopPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions["publishedContentsNewsOnTopPermission"]
    );
    const modifyPointsPublishedContentsPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions["modifyPointsPublishedContentsPermission"]
    );
    const sendContentPushNotificationPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions["sendContentPushNotificationPermission"]
    );
    const updateContentStickyPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions["updateContentStickyPermission"]
    );
    const deletePublishedContents = this.state.loggedInUserPermissions.includes(
      DefinedPermissions["deletePublishedContents"]
    );
    const addContentToListPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions["addContentToListPermission"]
    );
    const addOrRemoveFromBoxOfficePermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions["addOrRemoveFromBoxOfficePermission"]
    );
    const archivePublishedContentsPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions["archivePublishedContentsPermission"]
    );
    const rankedContentsActionsIconPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions["rankedContentsActionsIconPermission"]
    );
    const editPublishedContentsPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions["editPublishedContentsPermission"]
    );

    const PK = item.PK.replace("cont#", "");
    // console.log('itemitem', item)
    let isStickyPost = false;
    let isCampaign = false;
    if (
      item.stickyPost != undefined &&
      item.stickyPost != null &&
      item.stickyPost
    ) {
      isStickyPost = true;
    } else if (
      item.isInAppMessage != undefined &&
      item.isInAppMessage != null &&
      item.isInAppMessage
    ) {
      if (
        item.inAppMessageDetails != undefined &&
        item.inAppMessageDetails != null &&
        Object.keys(item.inAppMessageDetails).length > 0
      ) {
        isCampaign = true;
      }
    }
    const positionFromTop =
      item.tempPositionFromTop != undefined && item.tempPositionFromTop != null
        ? item.tempPositionFromTop
        : item.positionFromTop != undefined && item.positionFromTop != null
        ? item.positionFromTop
        : "";
    return isStickyPost || isCampaign || !item.archivedFromRedis ? (
      <div
        key={item.PK}
        draggable={isStickyPost || isCampaign ? false : true}
        className="noselect"
        id={item.PK}
        onDragOver={(ev) => ev.preventDefault()}
        onDragStart={this.handleDrag}
        onDrop={this.handleDrop}
        style={{
          backgroundColor: isStickyPost ? "red" : isCampaign ? "blue" : null,
          msUserSelect: "none",
        }}
      >
        {rankedContentsActionsIconPermission ? (
          <Menu
            menuButton={
              <div
                class="contentTitle"
                data-toggle="tooltip"
                title={`${
                  isStickyPost ? `Pos From Top : ${positionFromTop},\n` : ""
                }Points : ${item.points},\nLikes : ${item.likes},\nViews : ${
                  item.viewed
                },\nShares : ${item.sharedVideoCount},\nComments :${
                  item.commentsCount
                },\nCreated Date :${
                  item.contentCreatedDateTime
                    ? this.getPublishedDate(item.contentCreatedDateTime)
                    : "-"
                },\nCreator Handle : ${
                  item.originalCreatorHandle
                },\nCreator Name : ${
                  item.originalCreatorName
                },\nPublished Date :${
                  item.contentPublishedDateTime
                    ? this.getPublishedDate(item.contentPublishedDateTime)
                    : "-"
                }`}
              >
                <span class="content-title">{this.getContenttitle(item)}</span>
              </div>
            }
          >
            {/* TO DO */}
            {/* <MenuItem>
					<ContentInfo rank={true} item={item} />
				</MenuItem> */}
            {editPublishedContentsPermission ? (
              <Link to={`/editContent?${PK}`} target="_blank">
                <MenuItem>Edit Content</MenuItem>
              </Link>
            ) : null}
            {Auth.user.attributes &&
            Auth.user.attributes.email &&
            !isStickyPost &&
            !isCampaign &&
            Auth.user.attributes.phone_number &&
            publishedContentsNewsOnTopPermission &&
            item.contentMainCategory == "news" &&
            !item.archivedFromRedis ? (
              <MenuItem>
                <NewsOnTop
                  rank={true}
                  item={item}
                  displayToast={this.displayToast}
                  // updateContentPoints={this.updateContentPoints}
                  // replaceContentPoints={this.replaceContentPoints}
                />
              </MenuItem>
            ) : null}
            {Auth.user.attributes &&
            Auth.user.attributes.email &&
            Auth.user.attributes.phone_number &&
            modifyPointsPublishedContentsPermission &&
            item.contentMainCategory != "news" ? (
              <MenuItem>
                <AddPointsToContent
                  rank={true}
                  item={item}
                  displayToast={this.displayToast}
                  updateContentPoints={this.updateContentPoints}
                  replaceContentPoints={this.replaceContentPoints}
                />
              </MenuItem>
            ) : null}
            {sendContentPushNotificationPermission ? (
              <MenuItem>
                <SendPushNotification
                  item={item}
                  rank={true}
                  displayToast={this.displayToast}
                />
              </MenuItem>
            ) : null}
            {Auth.user.attributes &&
            Auth.user.attributes.email &&
            Auth.user.attributes.phone_number &&
            updateContentStickyPermission ? (
              <MenuItem>
                <ContentStickyActions
                  rank={true}
                  item={item}
                  displayToast={this.displayToast}
                  updateContentPoints={this.updateContentPoints}
                  replaceContentPoints={this.replaceContentPoints}
                />
              </MenuItem>
            ) : null}
            {Auth.user.attributes &&
            Auth.user.attributes.phone_number &&
            deletePublishedContents ? (
              <MenuItem>
                <DeleteContentAction
                  rank={true}
                  item={item}
                  displayToast={this.displayToast}
                  refreshContents={this.refreshContents}
                />
              </MenuItem>
            ) : null}
            {item.contentType == "Story" ? (
              <MenuItem>
                <ShareContentAction
                  rank={true}
                  item={item}
                  displayToast={this.displayToast}
                  refreshContents={this.refreshContents}
                />
              </MenuItem>
            ) : null}
            {Auth.user.attributes &&
            Auth.user.attributes.email &&
            Auth.user.attributes.phone_number &&
            addContentToListPermission ? (
              <MenuItem>
                <AddContentToListAction
                  item={item}
                  rank={true}
                  displayToast={this.displayToast}
                  updateContentPoints={this.updateContentPoints}
                  replaceContentPoints={this.replaceContentPoints}
                />
              </MenuItem>
            ) : null}
            {/* should not be a sticky post and it should be archived from redis */}
            {Auth.user.attributes &&
            item.archivedFromRedis &&
            !isStickyPost &&
            Auth.user.attributes.email &&
            Auth.user.attributes.phone_number &&
            addOrRemoveFromBoxOfficePermission ? (
              <MenuItem>
                <AddContentToBoxOfficeAction
                  rank={true}
                  item={item}
                  displayToast={this.displayToast}
                  refreshContents={this.refreshContents}
                  updateArchivedList={this.updateArchivedList}
                />
              </MenuItem>
            ) : null}
            {Auth.user.attributes &&
            !item.archivedFromRedis &&
            Auth.user.attributes.email &&
            !isStickyPost &&
            !isCampaign &&
            Auth.user.attributes.phone_number &&
            archivePublishedContentsPermission ? (
              <MenuItem>
                <ArchiveContentAction
                  rank={true}
                  item={item}
                  displayToast={this.displayToast}
                  refreshContents={this.refreshContents}
                  updateArchivedList={this.updateArchivedList}
                />
              </MenuItem>
            ) : null}
          </Menu>
        ) : null}
        <a href={`/editContent?${PK}`} target="_blank">
          <div class="contentImage">
            {/* <i class='fas fa-arrows-alt' /> */}

            <img src={this.getContentUri(item)} />
          </div>
        </a>
        <div class="analytics-main">
          <div class="analytics row">
            <div class="col-md-6">
              <i class="fas fa-heart" />
              <text>{item.likes}</text>
            </div>
            <div class="col-md-6">
              <i class="fas fa-eye" />
              <text>{item.viewed}</text>
            </div>
            <div class="col-md-6">
              <i class="fas fa-share" />
              <text>{item.sharedVideoCount}</text>
            </div>
            <div class="col-md-6">
              <i class="fas fa-comment" />
              <text>{item.commentsCount}</text>
            </div>
          </div>
          <div class="copybtn" onClick={() => this.checkCopied()}>
            <CopyToClipboard
              text={`${window.location.origin}/editContent?${PK}`}
            >
              <text>
                <i class="fa fa-copy"></i>
              </text>
            </CopyToClipboard>
          </div>
        </div>
      </div>
    ) : null;
  };
  onChange = async (sourceId, sourceIndex, targetIndex, targetId) => {
    const { publishedContentsList, dragId } = this.state;
    const dragItem = publishedContentsList[sourceIndex];
    const dropItem = publishedContentsList[targetIndex];
    const dragIndex = sourceIndex;
    const dropIndex = targetIndex;
    console.log(dropIndex, "dropIndex");
    console.log(dragIndex, "dragIndex");
    console.log(dragItem, "dragItemdragItem");

    if (dragIndex != dropIndex) {
      let loggedInUserHandle = "";
      const loggedInUserEmail = Auth.user.attributes
        ? Auth.user.attributes.email
        : "";
      if (loggedInUserEmail) {
        const emailParams = loggedInUserEmail.split("@");
        loggedInUserHandle = "@" + emailParams[0];
      }
      const isDraggedStickyPost =
        dragItem.stickyPost != undefined && dragItem.stickyPost != null
          ? dragItem.stickyPost
          : false;
      const parameters = {
        contentID: dragItem.PK,
        newsOnTopFor: "rank",
        ModeratorID: Auth.user.username,
        moderatorHandle: loggedInUserHandle,
        rank: parseInt(dropIndex) + 1,
        fromPosition: parseInt(dragIndex) + 1,
        isDraggedStickyPost,
      };
      console.log(parameters, "parameters");
      try {
        if (!isDraggedStickyPost) {
          const response = await ModifyContentPoints(parameters);
          console.log(response, "responseeeeeeeeeeee=============");

          if (response.statusCode == "A261") {
            var element = publishedContentsList[dragIndex];
            publishedContentsList.splice(dragIndex, 1);
            publishedContentsList.splice(dropIndex, 0, element);
            toast.success("Ranked Successfully", this.toastStyle);

            this.setState({ publishedContentsList: publishedContentsList });
          } else {
            toast.error("Failed To Rank the content", this.toastStyle);
          }
        } else if (isDraggedStickyPost) {
          console.log("it is a dragged post");
          toast.error(
            "You Cannot Drag Sticky Post or Campaign",
            this.toastStyle
          );
        }
      } catch (error) {
        return error;
      }
    }
  };
  render() {
    return (
      <div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        {this.state.loading ? <Spinner /> : null}
        <Header
          changeAppLanguage={this.changeAppLanguage}
          appLanguage={this.state.appLanguage}
        />

        <div>
          <label>Rank Contents</label>
        </div>
        {this.state.render && this.state.publishedContentsList ? (
          <div class="myGallery">
            {this.state.publishedContentsList &&
              this.state.publishedContentsList.map((row, index) =>
                this.renderTableRow(row, index)
              )}
          </div>
        ) : this.state.render ? (
          <div>No Data To Display</div>
        ) : (
          <div>Loading..</div>
        )}

        {this.state.nextToken != null && (
          <button onClick={this.loadMore} type="button" className="load-more">
            Load more
          </button>
        )}
      </div>
    );
  }
}

export default RankContents;
